<div class="flex menu-spacing flex-align-center header-sub-menu" [ngClass]="size">
	@if (itemsHandlerService.favoriteItemsArray.length > 0) {
		<div class="flex flex-align-center menu-spacing">
			@for (button of itemsHandlerService.favoriteItemsArray; track button) {
				@if (!button.hideOnDisable?.() || (button.hideOnDisable?.() && !(button.disabled && button.disabled?.()))) {
					<button
						class="favorite-button"
						matTooltipPosition="below"
						[matTooltip]="getTooltip(button, true) | translate"
						[ngClass]="{
							'no-text': noInlineText || button.noText?.(),
						}"
						(click)="HandleClick(button)"
						[disabled]="button.disabled ? button.disabled() : false">
						<mat-icon svgIcon="{{ button.icon() }}"></mat-icon>
						<span class="favorite-button-text">{{ button.text() | translate }}</span>
					</button>
				}
			}
		</div>
	}
	@if (itemsHandlerService.menuItemsArray.length > 0) {
		<div>
			<button class="sub-menu" mat-icon-button [matMenuTriggerFor]="menu">
				<mat-icon svgIcon="acies_overflow_menu_vertical"></mat-icon>
			</button>
			<mat-menu #menu="matMenu">
				@for (item of itemsHandlerService.menuItemsArray; track item) {
					@if (!item.hideOnDisable?.() || (item.hideOnDisable?.() && !(item.disabled && item.disabled?.()))) {
						<button
							mat-menu-item
							matTooltipShowDelay="500"
							matTooltipPosition="below"
							[matTooltip]="getTooltip(item, false) | translate"
							[matTooltipDisabled]="item.disabled && !item.disabled()"
							(click)="item.click()"
							[ngClass]="{ disabled: item?.disabled ? item.disabled() : false }"
							[disabled]="item.disabled ? item.disabled() : false">
							<mat-icon svgIcon="{{ item.icon() }}"></mat-icon>
							<span>{{ item.text() | translate }}</span>
						</button>
					}
				}
			</mat-menu>
		</div>
	}
</div>
